var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4471 18.2067C12.5248 18.0167 13.5546 17.6162 14.4775 17.0282C15.4005 16.4402 16.1986 15.6762 16.8263 14.7798C17.454 13.8833 17.899 12.872 18.1358 11.8036C18.3727 10.7352 18.3968 9.63061 18.2068 8.55289C18.0167 7.47517 17.6163 6.44543 17.0283 5.52246C16.4403 4.5995 15.6763 3.80138 14.7798 3.17369C13.8834 2.546 12.8721 2.10102 11.8037 1.86416C10.7353 1.6273 9.63069 1.6032 8.55297 1.79323C7.47525 1.98326 6.44551 2.3837 5.52254 2.9717C4.59958 3.55969 3.80146 4.32372 3.17377 5.22016C2.54608 6.1166 2.1011 7.12789 1.86424 8.1963C1.62738 9.26471 1.60328 10.3693 1.79331 11.447C1.98334 12.5248 2.38379 13.5545 2.97178 14.4775C3.55977 15.4004 4.3238 16.1985 5.22024 16.8262C6.11668 17.4539 7.12797 17.8989 8.19638 18.1358C9.26479 18.3726 10.3694 18.3967 11.4471 18.2067L11.4471 18.2067Z",
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10L10 15",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.83337L10 5.00004",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6f06ad1ce64dbecf96cd70f9db9465c4.svg";
export { ForwardRef as ReactComponent };